import { theme } from '@factorialco/deprecated-design-system'
import { CompensationsValueObjectsPaymentRequestStatusEnum } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

export const PaymentRequestStatus = {
  PAID: 'paid',
  IN_PROGRESS: 'in_progress',
  PENDING_TO_PAY: 'pending_to_pay',
} satisfies Record<string, CompensationsValueObjectsPaymentRequestStatusEnum | 'pending_to_pay'>

export type PaymentStatus = CompensationsValueObjectsPaymentRequestStatusEnum | 'pending_to_pay'

export const getPaymentRequestStatusColor = (status: PaymentStatus): string => {
  switch (status) {
    case PaymentRequestStatus.PAID:
      return theme.colors.viridian1000
    case PaymentRequestStatus.IN_PROGRESS:
      return theme.colors.group5
    case PaymentRequestStatus.PENDING_TO_PAY:
      return theme.colors.darker400
    default:
      return theme.colors.darker400
  }
}

export const getPaymentRequestStatusLabel = (status: PaymentStatus): string => {
  switch (status) {
    case PaymentRequestStatus.PAID:
      return i18n.t('compensations.payments.statuses.paid')
    case PaymentRequestStatus.IN_PROGRESS:
      return i18n.t('compensations.payments.statuses.sent_to_pay')
    case PaymentRequestStatus.PENDING_TO_PAY:
      return i18n.t('compensations.payments.statuses.pending_to_send')
    default:
      return status
  }
}
